import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import FogyasztoBaratEmbed from '../components/FogyasztoBaratEmbed';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground py-16 px-6 flex flex-col">
      <div className="container mx-auto max-w-5xl w-full">
        <Button asChild variant="ghost" className="mb-12 pl-0 hover:bg-transparent hover:text-accent font-sans text-xs tracking-widest">
          <Link to="/"><ChevronLeft className="w-4 h-4 mr-2" /> Vissza a főoldalra</Link>
        </Button>
        <h1 className="text-4xl md:text-5xl font-serif font-normal text-primary mb-12 tracking-wide uppercase border-b border-border/40 pb-8">
          Süti (Cookie) Tájékoztató
        </h1>
        
        {/* Dynamic Fogyasztó Barát Widget */}
        <FogyasztoBaratEmbed dataType="cookie" />
      </div>
    </div>
  );
};

export default CookiePolicy;
